import angular from 'angular';

module.exports = angular.module('common.directives.table-sortable', [])
.directive('tableSortable', function($parse) {
  return {
    restrict: 'C',
    controller: function($scope) {
      this.sort = function(key) {
        if (!$scope.onSort || $scope.onSort($scope, { key: key, asc: this.orderKey() !== key })) {
          $scope.$apply(function() {
            $scope.orderKey = ($scope.orderKey === key ? '-' : '') + key;
          });
        }
      };

      this.orderKey = () => $scope.orderKey;
    },
    link: function(scope, element, attrs) {
      scope.orderKey = scope.$eval(attrs.defaultSort);
      scope.onSort = attrs.onSort ? $parse(attrs.onSort) : null;
    }
  };
})
.directive('sort', function() {
  return {
    restrict: 'A',
    require: '?^tableSortable',
    scope: {},
    transclude: true,
    template: require('./sorted-column.jade')(),
    link: function(scope, element, attrs, sortController) {
      if (sortController) {
        scope.sortColumn = attrs.sort;
        scope.orderKey = sortController.orderKey;

        element.on('click', function () {
          sortController.sort(attrs.sort);
        });
      }
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/table-sortable.js
 **/